import React, { CSSProperties, HTMLAttributes, ReactNode } from 'react';
import { useReveal } from '../../hooks/useReveal';
type RevealTag = 'div' | 'li' | 'section' | 'span';
type RevealProps = {
  as?: RevealTag;
  /** Stagger delay in milliseconds */
  delay?: number;
  className?: string;
  style?: CSSProperties;
  children: ReactNode;
} & Omit<HTMLAttributes<HTMLElement>, 'className' | 'style' | 'children'>;
export function Reveal({
  as = 'div',
  delay = 0,
  className = '',
  style,
  children,
  ...rest
}: RevealProps) {
  const [ref, visible] = useReveal<HTMLElement>();
  return React.createElement(as, {
    ...rest,
    ref,
    className: `av-reveal ${visible ? 'is-visible' : ''} ${className}`.trim(),
    style: delay ? {
      ...style,
      transitionDelay: `${delay}ms`
    } : style
  }, children);
}